import { useEditor, Element } from "@craftjs/core";
import {
  Box,
  Typography,
  Grid,
  Button as MaterialButton,
  Card
} from "@mui/material";
import { CButton } from "./CButton";
import { CText } from "./CText";
import { CContainer } from "./CContainer";
import { CImage } from "./CImage";
import { CDrawUpModal } from "./CDrawUpModal";
import { CInput } from "./CInput";
import { CLink } from "./CLink";
import { CForm } from "./CForm";
import { CSelectBox } from "./CSelectBox";
import { CFAQ } from "./CFAQ";
import { CTable } from "./CTable";
import { CCarousel } from "./CCarousel";

export const CToolbox = () => {
  const { connectors } = useEditor();

  return (
    <Box px={2} py={2}>
      <Grid
        container
        spacing={1}
      >
        <Box pb={2}>
          <Typography>Drag to left to add</Typography>
        </Box>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) =>
              connectors.create(
                ref,
                <Element canvas is={CContainer} padding={20} />
              )
            }
            variant="contained"
            data-cy="toolbox-container"
          >
            Container
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) =>
              connectors.create(
                ref,
                <Element canvas is={CForm} padding={20} />
              )
            }
            variant="contained"
            data-cy="toolbox-form"
          >
            Form
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) =>
              connectors.create(ref, <CButton text="Button" size="small" />)
            }
            variant="contained"
            data-cy="toolbox-button"
          >
            Button
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CText text="The text" />)}
            variant="contained"
            data-cy="toolbox-text"
          >
            Text
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CLink text="Link text" link="#" />)}
            variant="contained"
            data-cy="toolbox-link"
          >
            Link
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CInput text="" />)}
            variant="contained"
            data-cy="toolbox-input"
          >
            Input
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CSelectBox />)}
            variant="contained"
            data-cy="toolbox-selectbox"
          >
            SelectBox
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CImage />)}
            variant="contained"
            data-cy="toolbox-image"
          >
            Image
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <Card />)}
            variant="contained"
            data-cy="toolbox-card"
          >
            Card
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CDrawUpModal />)}
            variant="contained"
            data-cy="toolbox-draw-up-modal"
          >
            DrawUpModal
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CFAQ />)}
            variant="contained"
            data-cy="toolbox-faq"
          >
            FAQ
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CTable />)}
            variant="contained"
            data-cy="toolbox-table"
          >
            Table
          </MaterialButton>
        </Grid>
        <Grid container direction="column" item>
          <MaterialButton
            ref={(ref: any) => connectors.create(ref, <CCarousel />)}
            variant="contained"
            data-cy="toolbox-carousel"
          >
            Carousel
          </MaterialButton>
        </Grid>
      </Grid>
    </Box>
  );
};
